import React, { useMemo } from 'react'
import { rankWith, and, scopeEndsWith } from '@jsonforms/core'
import { JsonForms } from '@jsonforms/react'
import { materialCells } from '@jsonforms/material-renderers'
import { withJsonFormsControlProps } from '@jsonforms/react'

import ComponentWrapper from 'designer/component/display/layout/control/ComponentWrapper'
import DragContainerWrapper from 'designer/component/system/layout/control/DragContainerWrapper'
import CustomCard from 'designer/component/container/card/Card'

import {
  createDisplayRenderer,
  createSystemRenderer,
} from 'designer/component/control/renderer'
import Container from './Container'

export const CardSystem = (props) => {
  let { data, schema, uischema, handleChange, path, config } = props
  const renderers = useMemo(
    () => createSystemRenderer(uischema.elements),
    [JSON.stringify(uischema.elements)],
  )

  return (
    <DragContainerWrapper {...props}>
      <CustomCard {...props}>
        <Container {...props} renderers={renderers} />
      </CustomCard>
    </DragContainerWrapper>
  )
}

export const SubCardSystem = (props) => {
  let { data, schema, uischema, handleChange, path, config } = props
  const renderers = useMemo(
    () => createSystemRenderer(uischema.elements),
    [JSON.stringify(uischema.elements)],
  )

  return (
    <DragContainerWrapper {...props}>
      <CustomCard {...props}>
        <Container {...props} renderers={renderers} />
      </CustomCard>
    </DragContainerWrapper>
  )
}

export const CardDisplay = (props) => {
  let { data, schema, uischema, handleChange, path, config } = props
  const renderers = useMemo(
    () => createDisplayRenderer(uischema.elements),
    [JSON.stringify(uischema.elements)],
  )

  return (
    <ComponentWrapper {...props}>
      <CustomCard {...props}>
        <Container {...props} renderers={renderers} />
      </CustomCard>
    </ComponentWrapper>
  )
}

export const SubCardDisplay = (props) => {
  let { data, schema, uischema, handleChange, path, config } = props
  const renderers = useMemo(
    () => createDisplayRenderer(uischema.elements),
    [JSON.stringify(uischema.elements)],
  )

  return (
    <ComponentWrapper {...props}>
      <CustomCard {...props}>
        <Container {...props} renderers={renderers} />
      </CustomCard>
    </ComponentWrapper>
  )
}

export const cardTester = rankWith(
  3,
  and(scopeEndsWith('card'), (schema) => !schema.subGroup),
)

export const subCardTester = rankWith(
  3,
  and(scopeEndsWith('card'), (schema) => schema.subGroup),
)

export const cardSystem = {
  tester: cardTester,
  renderer: withJsonFormsControlProps(CardSystem),
}

export const subCardSystem = {
  tester: subCardTester,
  renderer: withJsonFormsControlProps(SubCardSystem),
}

export const cardDisplay = {
  tester: cardTester,
  renderer: withJsonFormsControlProps(CardDisplay),
}

export const subCardDisplay = {
  tester: subCardTester,
  renderer: withJsonFormsControlProps(SubCardDisplay),
}
